import type { DeviceCategory } from "@/services/my-hardware/my-hardware.types";

export const MY_HARDWARE_TABS = {
  myAssets: "my-assets",
  myTeam: "my-team",
} as const;

export const DEVICE_PLACEHOLDER_ART: Record<DeviceCategory, string> = {
  laptop: "/img/laptop-icon.svg",
  monitor: "/img/no_logo_image.png",
  other: "/img/no_logo_image.png",
};
